import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { BrowserRouter as Router, Route, Switch  , Link } from "react-router-dom";


import Config from "../../../Config.js";
class DropdownProfile extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
   

    this.state = {
      dropdownOpen: false,
      CurrentUserLoginName: localStorage.getItem("loginName"),
      CurrentUserLoginImage: localStorage.getItem("loginUserImage"),
      userrole: localStorage.getItem("loginRoleName"),
    };
    // console.log("loginName", localStorage.getItem("loginUserImage"))
  }
  // CreateLogout() {
  // 	this.props.history.push("/Login1");
  // }
  componentDidMount() {
    setInterval(() => {
      this.setState({
        CurrentUserLoginName: localStorage.getItem("loginName"),
      });
      this.setState({
        CurrentUserLoginImage: localStorage.getItem("loginUserImage"),
      });
    }, 1000);
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  toggleMegaMenu() {
    this.setState({ collapseMegaMenu: !this.state.collapseMegaMenu });
  }

  // CreateLogout() {
  //   this.props.history.push("/Logout");
  // }
  // Profile() {
  //   this.props.history.push("/UserProfile");
  // }
  // Inbox() {
  //   this.props.history.push("/inbox/inbox");
  // }
  // Setting() {
  //   this.props.history.push("/setting/paymentandinvoices");
  // }
  render() {
    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
        className="dropdown navbar-user"
        tag="li"
      >
        <DropdownToggle tag="a">
          {/* <img src="../assets/img/user/user-13.jpg" alt="" /> */}
          <img
            src={this.state.CurrentUserLoginImage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = "../assets/img/new-images/images.png";
            }}
          ></img>
          <span className="d-none d-md-inline">
            {this.state.CurrentUserLoginName}
          </span>{" "}
          <b className="caret"></b>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu dropdown-menu-right" tag="ul">
          {/* <DropdownItem href='/inbox/inbox'><span className="badge badge-danger pull-right">2</span> Inbox</DropdownItem> */}
          {this.state.userrole !== "SuperAdmin" ? (
            <>
              <DropdownItem
              href="/UserProfile"
              >
                {/* <Link to="/UserProfile"> </Link> */}
                User Profile
                </DropdownItem>
              <DropdownItem 
              href="/paymentandinvoices"
              >
              {/* <Link to="/paymentandinvoices"></Link> */}
              Setting
              </DropdownItem>
              <div className="dropdown-divider"></div>
            </>
          ) : (
            <></>
          )}
          <DropdownItem  
          href="/Logout"
          //onClick={()=>{this.CreateLogout()}}
          >
            {/* <Link to="/Logout"></Link> */}
          Log Out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default DropdownProfile;
